import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { formatCurrency } from '@icc/shared/currency';
import { DiscountsAndMultipliersService } from '@icc/b2b/shared';
import { Subscription } from 'rxjs';
import { ConfigService } from '@icc/shared/config.service';
import { core } from '@icc/shared/helpers/b2b';

@Pipe({
    name: 'multiplier',
    pure: false,
})
export class MultiplierPipe implements PipeTransform {
    private subscription?: Subscription;
    private loaded = false;

    constructor(
        private discountsAndMultipliersService: DiscountsAndMultipliersService,
        private readonly ref: ChangeDetectorRef,
    ) {}

    transform(value: any, productId: number, withPromotion = false): any {
        if (!this.discountsAndMultipliersService.loaded$) {
            return null;
        }
        if (!this.subscription) {
            this.subscription = this.discountsAndMultipliersService.loaded$.subscribe(val => {
                this.loaded = val;
                this.ref.markForCheck();
            });
        }
        if (!this.loaded) {
            return null;
        }
        const priceBeforePromotion = this.discountsAndMultipliersService.getProductSalesPrice(value, productId);

        if (!withPromotion) {
            return priceBeforePromotion;
        }

        const promotion = this.discountsAndMultipliersService.getProductPromotion(productId);
        if (promotion) {
            return core.round(priceBeforePromotion - core.round(promotion.value * priceBeforePromotion / 100));
        }
        return priceBeforePromotion;
    }

    ngOnDestroy() {
        this.dispose();
    }

    private dispose() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    }
}
